import LegalPageLayout from "./LegalPageLayout";

export default function ConditionsPage() {
  return (
    <LegalPageLayout
      title="Conditions d'utilisation"
      subtitle="Dernière mise à jour : décembre 2025"
      testid="page-conditions"
    >
      <section>
        <p>
          En utilisant l&apos;application Echo, tu acceptes les présentes conditions d&apos;utilisation.
          Merci de les lire attentivement avant toute utilisation.
        </p>
      </section>

      <section>
        <h2>1. Objet</h2>
        <p>
          Echo est une application mobile de bien-être mental permettant à ses utilisateurs de suivre
          un programme personnalisé afin de gérer leur stress, gagner confiance en eux et se sentir mieux.
        </p>
      </section>

      <section>
        <h2>2. Accès à l&apos;application</h2>
        <p>
          L&apos;application est accessible gratuitement en téléchargement depuis l&apos;App Store
          et Google Play. Certaines fonctionnalités peuvent être proposées via un abonnement premium.
        </p>
      </section>

      <section>
        <h2>3. Compte utilisateur</h2>
        <p>
          Tu es responsable de la confidentialité de tes identifiants et des activités qui se déroulent
          sur ton compte. Merci de nous prévenir immédiatement en cas d&apos;utilisation non autorisée.
        </p>
      </section>

      <section>
        <h2>4. Contenu et santé mentale</h2>
        <p>
          Echo est un outil de bien-être et de développement personnel. Il ne remplace en aucun cas
          un avis médical, un diagnostic ou un traitement professionnel. Si tu traverses une période
          difficile, nous t&apos;encourageons à consulter un professionnel de santé.
        </p>
      </section>

      <section>
        <h2>5. Propriété intellectuelle</h2>
        <p>
          L&apos;ensemble des contenus proposés dans l&apos;application (textes, images, sons, code)
          sont la propriété exclusive d&apos;Echo. Toute reproduction non autorisée est interdite.
        </p>
      </section>

      <section>
        <h2>6. Résiliation</h2>
        <p>
          Tu peux supprimer ton compte à tout moment depuis les paramètres de l&apos;application.
          Nous nous réservons le droit de suspendre un compte en cas de non-respect des présentes conditions.
        </p>
      </section>

      <section>
        <h2>7. Modifications</h2>
        <p>
          Nous pouvons modifier ces conditions à tout moment. En cas de changement important, tu seras
          informé dans l&apos;application ou par email.
        </p>
      </section>

      <section>
        <h2>8. Contact</h2>
        <p>
          Pour toute question, écris-nous à <strong>support@theecho.fr</strong>.
        </p>
      </section>
    </LegalPageLayout>
  );
}
